import { Button } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { useTranslation } from "react-i18next";
import { useAuth } from "@context/AuthContext";

export function GoogleLoginButton() {
  const { t } = useTranslation();
  const { loginWithGoogle } = useAuth();

  return (
    <Button
      variant="outlined"
      size="large"
      startIcon={<GoogleIcon />}
      onClick={loginWithGoogle}
      sx={{
        px: 4,
        py: 1.5,
        borderRadius: 9999,
        textTransform: "none",
        fontSize: 16,
        fontWeight: 500,
      }}
    >
      {t("account.signIn")}
    </Button>
  );
}
